import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PHBHPFeaturePackageChcService } from '../ph-bhp-feature-package-chc.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from 'src/app/app.config';
import { Subscription } from 'rxjs';
//import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'app-ph-bhp-chc-configure',
  templateUrl: './ph-bhp-chc-configure.component.html',
  styleUrls: ['./ph-bhp-chc-configure.component.css']
})
export class PhBhpChcConfigureComponent implements OnInit {

  institutions: any;
  InstitutionsList: [any];
  itemChange: boolean = false;
  enablePhase2: boolean = false;
  subscription: Subscription;
  packageSubscription: Subscription;
  userData: any;
  selectedInstitution
  @ViewChild('template') template: TemplateRef<any>;
  modalRef: BsModalRef;
  generalDetails:any;
  searchText;
  isDisabledState : boolean = false;
  institutionID;
  generalSettingID: number;
  packageID: number;
  myGroup = new UntypedFormGroup({
    timeIntervel : new UntypedFormControl([6,[Validators.pattern('/\b(0?[1-9]|1[0-9]|2[0-4])\b/g')]])
  });
  selected;
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(private service: PHBHPFeaturePackageChcService,private listservice: PHBHPListApiService, private layoutService: PHBHPLayoutPackageService,private modalService: BsModalService, public config: AppConfig) { }

  ngOnInit() {
    if (this.layoutService.institutionID) {
      this.institutionID = this.layoutService.institutionID
      this.institutions = this.config.institutions;
      this.OnInstitutionsChanges()
      this.getConfigDetails(this.institutionID);
    }
    this.packageID = this.layoutService.packageID;
    this.packageSubscription = this.layoutService.packageIDSubject.asObservable().subscribe((res) => {
      this.packageID = this.layoutService.packageID;
    });
    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.institutionID = this.layoutService.institutionID
      this.institutions = this.config.institutions;
      this.getConfigDetails(this.institutionID);
      this.OnInstitutionsChanges()
    });
  }

  ngOnDestroy(){
    if(this.subscription)
      this.subscription.unsubscribe();
    if(this.packageSubscription)
      this.packageSubscription.unsubscribe();
  }

  OnInstitutionsChanges() {
    if (this.institutions && !this.itemChange) {
      
    }
  }

  numberOnly(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    var testnumber = parseInt(event.target.value+""+event.key); 
    if( testnumber <= 24){
      return true;
    } else {
      return false;
    }
  }

  onInstitutionChange(value) {
    if (this.InstitutionsList) {
      this.layoutService.institutionID = value;
      this.layoutService.institutionIDSubject.next(value);
      var institution = this.InstitutionsList.find(x => x.institution.institutionID === value).institution
      this.packageID = institution.packageID;
      this.selected = institution.institutionID;
      this.selectedInstitution = institution.institutionName;
    }
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }

  openmodal(template: TemplateRef<any>){
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' }));
  }

  getConfigDetails(institutionid){
    
  }

  saveConfigDetails(template: TemplateRef<any>) {
    
  }

  saveNosterilityDetails (template){
    
  }
  
  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }
}
